import { useEffect, useState } from 'react'
import { RefreshCw, X } from 'lucide-react'

import {
  iniciarVersionWatch,
  recarregarNaVersaoNova,
} from '@core/versionWatch'

/** Avisa que saiu versão nova enquanto este separador esteve aberto.
 *
 *  Um separador aberto há horas não navega, logo nunca volta a pedir o
 *  HTML, logo continua a correr o código de ontem sem nada que o diga.
 *  Aconteceu: a beta.123 estava publicada e o separador aberto mostrava
 *  o friso da beta.122, com os comandos noutros sítios, e não havia
 *  maneira de a pessoa perceber porquê.
 *
 *  O aviso não recarrega sozinho, de propósito: pode estar trabalho por
 *  gravar no ecrã, e recarregar é decisão de quem está a trabalhar.
 *  Dispensá-lo cala-o até ao próximo arranque; a versão nova continua a
 *  ser servida no recarregamento seguinte, seja ele qual for. */
export default function VersionUpdateBanner() {
  const [versaoNova, setVersaoNova] = useState<string | null>(null)
  const [dispensado, setDispensado] = useState(false)
  const [aRecarregar, setARecarregar] = useState(false)

  useEffect(() => iniciarVersionWatch({ aoDescobrir: setVersaoNova }), [])

  if (!versaoNova || dispensado) return null

  return (
    <div
      role="status"
      className="flex items-center gap-3 border-b border-[var(--color-note-border)] bg-[var(--color-note-bg)] px-4 py-2 text-sm text-[var(--color-note-text)]"
    >
      <RefreshCw className="h-4 w-4 shrink-0 text-[var(--color-note-text)]" aria-hidden />
      <p className="min-w-0 flex-1">
        Está publicada a versão <strong>{versaoNova}</strong>. Este separador
        ainda está a correr a anterior: recarrega para a usares. Se tiveres
        trabalho por gravar, grava primeiro.
      </p>
      <button
        type="button"
        disabled={aRecarregar}
        onClick={() => {
          setARecarregar(true)
          void recarregarNaVersaoNova()
        }}
        className="shrink-0 rounded border border-[var(--color-note-border)] bg-sky-500/20 px-3 py-1 font-medium text-sky-50 hover:bg-sky-500/30 disabled:opacity-60"
      >
        {aRecarregar ? 'A recarregar…' : 'Recarregar'}
      </button>
      <button
        type="button"
        aria-label="Dispensar o aviso de versão nova"
        title="Dispensar"
        onClick={() => setDispensado(true)}
        className="shrink-0 rounded p-1 text-[var(--color-note-text)] hover:bg-sky-500/20 hover:text-[var(--color-note-text)]"
      >
        <X className="h-4 w-4" aria-hidden />
      </button>
    </div>
  )
}
